module.exports = __webpack_public_path__ + "img/ciclebg2.a3cec3fb.svg";